(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.BadgeBuzzMoney = api;
})(typeof window !== 'undefined' ? window : globalThis, function() {
  'use strict';

  function digitOption(value, fallback) {
    var number = Number(value);
    return Number.isInteger(number) && number >= 0 && number <= 20 ? number : fallback;
  }

  function groupedFallback(value, minimumFractionDigits, maximumFractionDigits) {
    var fixed = value.toFixed(maximumFractionDigits);
    if (maximumFractionDigits > minimumFractionDigits) {
      var parts = fixed.split('.');
      while (parts[1] && parts[1].length > minimumFractionDigits && parts[1].endsWith('0')) {
        parts[1] = parts[1].slice(0, -1);
      }
      fixed = parts[1] ? parts.join('.') : parts[0];
    }
    var numberParts = fixed.split('.');
    numberParts[0] = numberParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return numberParts.join('.');
  }

  function format(value, options) {
    options = options || {};
    var amount = Number(value);
    if (!Number.isFinite(amount)) return '';

    var minimumFractionDigits = digitOption(options.minimumFractionDigits, 2);
    var maximumFractionDigits = digitOption(options.maximumFractionDigits, Math.max(2, minimumFractionDigits));
    if (maximumFractionDigits < minimumFractionDigits) maximumFractionDigits = minimumFractionDigits;
    var locale = options.locale || 'en-US';
    var currency = options.currency;

    try {
      if (currency) {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: minimumFractionDigits,
          maximumFractionDigits: maximumFractionDigits,
        }).format(amount);
      }
      return (options.currencySymbol == null ? '$' : options.currencySymbol) + amount.toLocaleString(locale, {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
      });
    } catch (error) {
      var prefix = options.currencySymbol == null ? (currency === 'USD' || !currency ? '$' : currency + ' ') : options.currencySymbol;
      return prefix + groupedFallback(amount, minimumFractionDigits, maximumFractionDigits);
    }
  }

  return Object.freeze({ format: format });
});
